import AppLayout from "../../../shared/components/AppLayout";
import { siteTexts } from "../../../shared/i18n/siteTexts";
import ChallengeEnginePanel from "../components/ChallengeEnginePanel";

export default function PocoPage() {
  return (
    <AppLayout>
      <ChallengeEnginePanel
        title={siteTexts.challenges.modes.poco.title}
        description={siteTexts.challenges.modes.poco.description}
        mode="admin"
        challengeType="poco"
      />
    </AppLayout>
  );
}
